export default __webpack_public_path__ + "static/media/graph_selected.b93f1c6b.svg";